export default class StoreMenuModel {
  itemStoreCode;
  itemCode;
  name;
  pictureFileName1;
  pictureFileName2;
  price;
  rdPrice;
  isTax1;
  isTax2;
  memo;
  menuType;
  isSoldOut;
  descriptionImageUrl1;
  descriptionImageUrl2;
  descriptionImageUrl3;
  descriptionImageUrl4;
  linkItemCode;
  purchaseLimitCount;
  toppingGroups;
  setMenuGroups;

  // 내부 로직으로 추가되는 속성
  linkMenu;

  constructor(data) {
    Object.assign(this, data);
  }
}
